import { AdvisorHeadshot } from '@components/MiscComponents/AdvisorHeadShot';
import { FC } from 'react';
import {
  AdvisorContactCardWrapper,
  AdvisorDetailsWrapper,
  AdvisorHeadshotWrapper,
  AdvisorSubTitles,
  AdvisorTitle,
} from './style';

interface AdvisorContactCardProps {
  img: string;
  header: string;
  subheaders: string | string[];
}

export const AdvisorContactCard: FC<AdvisorContactCardProps> = ({ img, header, subheaders }) => {
  return (
    <AdvisorContactCardWrapper>
      <AdvisorHeadshotWrapper>
        <AdvisorHeadshot img={img} alt_text={`${header} Headshot`} />
      </AdvisorHeadshotWrapper>

      <AdvisorDetailsWrapper>
        <AdvisorTitle>{header}</AdvisorTitle>

        {subheaders &&
          //if it's an array, map over it, if it's a single string, just render it
          (Array.isArray(subheaders) ? (
            subheaders.map((subheader, index) => (
              <AdvisorSubTitles key={index}>{subheader}</AdvisorSubTitles>
            ))
          ) : (
            <AdvisorSubTitles>{subheaders}</AdvisorSubTitles>
          ))}
      </AdvisorDetailsWrapper>
    </AdvisorContactCardWrapper>
  );
};

export default AdvisorContactCard;
